import { render, staticRenderFns } from "./CytomineTerm.vue?vue&type=template&id=23b57a24&scoped=true&"
import script from "./CytomineTerm.vue?vue&type=script&lang=js&"
export * from "./CytomineTerm.vue?vue&type=script&lang=js&"
import style0 from "./CytomineTerm.vue?vue&type=style&index=0&id=23b57a24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b57a24",
  null
  
)

export default component.exports